import React, { useRef, useState } from "react";
import { Card, Button, Form, InputGroup } from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import ProtectedButton from "../RBAC/ProtectedButton";
import { useRBAC } from "../../context/RBACContext";

export default function RFQUpload({ onUpload, documentType }) {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState("");
  const { hasPermission } = useRBAC();

  const uploadPermission = documentType === "RFQ" ? "rfqUpload" : "proposalUpload";
  const canUpload = hasPermission(uploadPermission);

  const handleFileSelect = (e) => {
    if (!canUpload) return;
    const selected = e.target.files[0];
    if (selected) setFile(selected);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (!canUpload) return;
    if (e.dataTransfer.files.length > 0) setFile(e.dataTransfer.files[0]);
  };

  const handlePasteLink = () => {
    if (!canUpload) return;
    const link = document.getElementById("pasteLinkInput").value.trim();
    if (link) setFile({ name: link, isLink: true });
  };

  const handleSave = () => {
    if (file) onUpload(file, description, true);
    setFile(null);
    setDescription("");
  };

  return (
    <div
      className="mt-auto p-2 border-top bg-white"
      style={{ display: "flex", justifyContent: "center" }}
    >
      {!file ? (
        /* --- Upload UI --- */
        <Card
          className="shadow-sm text-center p-3 border-0 rounded-4"
          style={{
            border: "2px dashed #d0d0d0",
            background: "#fafafa",
            cursor: canUpload ? "pointer" : "not-allowed",
            maxWidth: "900px",
            width: "100%",
            opacity: canUpload ? 1 : 0.6,
          }}
          onClick={() => canUpload && fileInputRef.current.click()}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
        >
          <img
            src="/images/imagedrop.svg"
            alt="upload"
            style={{
              width: 110,
              // marginBottom: 20,
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              maxHeight: 60,
            }}
          />
          <h8 className="fw-semibold mb-1" style={{ color: "#1b1b2f" }}>
            <span className="text-danger">Click</span> to Upload <span className="text-danger">{documentType}</span>  Documents or{" "}
            <span className="text-secondary">Drag’n’Drop</span>
          </h8>

          <div className="text-muted mb-1 fw-medium" style={{ fontSize: "14px" }}>or</div>

          <InputGroup className="mb-2" style={{ maxWidth: 500, margin: "0 auto", maxHeight: 20 }}>
            <Form.Control
              id="pasteLinkInput"
              type="text"
              placeholder="Paste Link Here"
              className="py-2"
              style={{ borderRight: "none" }}
            />
            <ProtectedButton
              permission={documentType === "RFQ" ? "rfqUpload" : "proposalUpload"}
              variant="dark"
              onClick={handlePasteLink}
              style={{
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                backgroundColor: "#151c48",
                color: "#fff",
              }}
            >
              <ArrowRight size={20} />
            </ProtectedButton>
          </InputGroup>

          <div
            className="text-muted mt-4"
            style={{ fontSize: "10px", opacity: 0.8 }}
          >
            🔒 All uploads are secure and confidential.
          </div>

          <input
            type="file"
            ref={fileInputRef}
            className="d-none"
            onChange={handleFileSelect}
          />
        </Card>
      ) : (
        /* --- File Details UI --- */
        <Card
          className="p-4 shadow-sm border-0 rounded-4"
          style={{
            background: "#fff",
            maxWidth: "750px",
            width: "100%",
          }}
        >
          <div className="mb-3">
            <div
              className="bg-light rounded-3 py-3 px-4 fw-semibold"
              style={{ color: "#333" }}
            >
              {file?.name}
            </div>
          </div>

          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Brief Description here..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mb-4"
          />

          <div className="d-flex justify-content-end gap-3">
            <ProtectedButton
              permission={documentType === "RFQ" ? "rfqUpload" : "proposalUpload"}
              variant="outline-secondary"
              onClick={() => setFile(null)}
              className="rounded-3 px-4 py-2 fw-medium"
            >
              Cancel
            </ProtectedButton>
            <ProtectedButton
              permission={documentType === "RFQ" ? "rfqUpload" : "proposalUpload"}
              onClick={handleSave}
              className="btn btn-dark text-white"
              style={{ backgroundColor: "#181D4C", border: "none" }}
            >
              Save
            </ProtectedButton>
          </div>
        </Card>
      )}
    </div>
  );
}
